export const updateContactInfoInitialState = {
    email: undefined,
    mobile: undefined,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvd2lkZ2V0cy9Db250YWN0SW5mb3JtYXRpb24vZm9ybS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxNQUFNLENBQUMsTUFBTSw2QkFBNkIsR0FBMkI7SUFDakUsS0FBSyxFQUFFLFNBQVM7SUFDaEIsTUFBTSxFQUFFLFNBQVM7Q0FDcEIsQ0FBQyJ9